import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ServicesSection from './components/ServicesSection';
import FleetSection from './components/FleetSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="w-full font-lato">
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <FleetSection />
      <ContactSection />
      <Footer />
    </div>
  );
}
